export default __webpack_public_path__ + "static/media/html-logo.a88fa7fd.png";